import { MenuItem } from "../../../components/@types";

// eslint-disable-next-line no-shadow
export enum YaraTestRunItemType {
  HASH = "hash",
  TAG = "tag"
}

export interface YaraTestRunData {
  hashes: Array<string>;
  tags: Array<string>;
}

export type YaraTestRunRequest = YaraTestRunData & {
  revision_id: string;
};

export interface YaraTestRunResponse {
  testrun_id: number;
}

export interface YaraTestRunResult {
  id: number;
  result: boolean;
  rules: Array<string>;
}

export interface YaraTestRunSample {
  id: number;
  results: Array<YaraTestRunResult>;
  sha1: string;
}

interface YaraTestRunTag {
  id: number;
  name: string;
}

interface YaraTestRunHash {
  id: number;
  hash: string;
}

export interface YaraTestRunResultsResponse {
  id: number;
  status: number;
  created: Date;
  finished: Date;
  samples: Array<YaraTestRunSample>;
  tags: Array<YaraTestRunTag>;
  hashes: Array<YaraTestRunHash>;
}

export interface YaraTestRunSampleData {
  id: number;
  sha1: string;
  file_count: number;
  first_seen: string;
  threat_name?: string;
  location: string;
  sample_available: boolean;
  file_size: number;
  int_submission_analyzer?: number;
  file_name?: string;
  threat_status: string;
  factor: number;
  sample_processing_status?: number;
  user_tags: string[];
}

export interface YaraTestRunSamplesResponse {
  data: Array<YaraTestRunSampleData>;
}

export type YaraTestRunMenuItem = MenuItem & { type: YaraTestRunItemType };

export type YaraTestRunMenuItems = Array<YaraTestRunMenuItem>;

export type YaraTestRunPreviewData = {
  hash: string;
  resultId: number;
};
